module.exports = __webpack_public_path__ + "img/close.87b30a0b.svg";